import axios from "axios"

import { devMode } from "./base"

const baseDomain = `https://m-ins${devMode ? "-dev" : ""}.mioto.vn`


export function getInitInsurance() {
	return axios({
			withCredentials: true,
			method: "GET",
			url: `${baseDomain}/insurance/init`
	})
}

export function getVehicleModel(data) {
	const makeId = data.makeId ? `makeId=${data.makeId}` : '';
	const transmission = data.transmission ? `&transmission=${data.transmission}` : '';

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/insurance/models?${makeId}${transmission}`		
	})
}

// makeId: int, transmission: int

export function getInsurancePrice(data) {
	const modelId = data.modelId ? `modelId=${data.modelId}` : '';
	const transmission = data.transmission ? `&transmission=${data.transmission}` : '';
	const year = data.year ? `&year=${data.year}` : '';
	const regDay = data.regDay ? `&regDay=${data.regDay}` : '';
	const regType = data.regType ? `&regType=${data.regType}` : '';
	const carOrigin = data.carOrigin ? `&carOrigin=${data.carOrigin}` : '';

	let terms = ""

	if (data.terms && data.terms.length > 0) {
		terms = `&terms=${data.terms.join(";")}` 
	}

	
// modelId: int, transmission: int, regDay: long, regType (registry): int, terms: list<String> separate ";"

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/insurance/price?${modelId}${transmission}${regDay}${regType}${terms}${year}${carOrigin}`		
	})
}


export function getTNDSInsPrice(data) {


	const regType = data.regType ? `regType=${data.regType}` : '';
	const vehicleType = data.vehicleType ? `&vehicleType=${data.vehicleType}` : '';

	const buuySeat = `&buySeat=${data.buySeat}`;
	

	// int regType, int vehicleType (4c, Bán tải: 1, 7c: 2), boolean buuySeat (default: yes)

	
	// https://m-ins-dev.mioto.vn/insurance/price-tnds

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/insurance/price-tnds?${regType}${vehicleType}${buuySeat}`		
	})
}

export function orderInsurance(data) {
	const type = `type=${data.type}`;
	const name = `&name=${data.name}`;
	const phoneNumber = `&phoneNumber=${data.phoneNumber}`;
	const comment = data.comment && data.comment !== "" ? `&comment=${data.comment}` : '';
	const modelName = data.modelName && data.modelName !== "" ? `&modelName=${data.modelName}` : '';
	
	const modelId = data.modelId ? `&modelId=${data.modelId}` : '';
	const transmission = data.transmission ? `&transmission=${data.transmission}` : '';
	const year = data.year ? `&year=${data.year}` : '';
	const regDay = data.regDay ? `&regDay=${data.regDay}` : '';
	const regType = data.regType ? `&regType=${data.regType}` : '';
	const price = data.price ? `&price=${encodeURIComponent(data.price)}` : '';

	// const regType = data.regType ? `regType=${data.regType}` : '';
	const vehicleType = data.vehicleType ? `&vehicleType=${data.vehicleType}` : '';

	const buuySeat = data.buuySeat !== undefined ? `&buuySeat=${data.buuySeat}` : '';
	const priceTNDS = data.priceTNDS ? `&priceTNDS=${encodeURIComponent(data.priceTNDS)}` : '';

	
	let terms = ""

	if (data.terms && data.terms.length > 0) {
		terms = `&terms=${data.terms.join(";")}` 
	}

	
	return axios({
		withCredentials: true,
		method: "POST",
		url: `${baseDomain}/insurance/order?${type}${name}${phoneNumber}${comment}${modelName}${modelId}${transmission}${regDay}${regType}${terms}${price}${year}${vehicleType}${buuySeat}${priceTNDS}`		
	})
}